<template>
  <div class="connection-version-update">
    <p class="connection-version-update-copy">
      {{ connectionVersionUpdateCopy }}
    </p>
    <BaseButton
      kind="auxiliary"
      type="secondary"
      :text="
        updating ? connectionVersionUpdatingLabel : connectionVersionUpdateLabel
      "
      :state="updating ? 'loading' : 'default'"
      @click="$emit('update')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BaseButton from "@/components/base/BaseButton.vue";

import {
  connectionVersionUpdateCopy,
  connectionVersionUpdateLabel,
  connectionVersionUpdatingLabel,
} from "./connectionVersionUpdate";

export default defineComponent({
  components: { BaseButton },
  props: {
    updating: { type: Boolean, required: true },
  },
  emits: {
    update: () => true,
  },
  setup() {
    return {
      connectionVersionUpdateCopy,
      connectionVersionUpdateLabel,
      connectionVersionUpdatingLabel,
    };
  },
});
</script>

<style scoped lang="scss">
.connection-version-update {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.connection-version-update-copy {
  margin: 0;
  @extend %font-body-regular;
  @include themed() {
    color: t($grey-50);
  }
}
</style>
